





































































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData } from "@/models/app-data";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { AlternateGSRPQualifierContent } from "@/models/content/alternate-gsrp-qualifier";
import { matchQualifiers, QualifierRule } from "@/models/rules";

@Component({
  components: {
    FooterButton,
  },
})
export default class AlternateGSRPQualifier extends Mixins(CommonMixin) {
  content: AlternateGSRPQualifierContent = {} as AlternateGSRPQualifierContent;
  PercentDone = 80;
  noGraduationChecked = false;
  illiterateChecked = false;
  noEnglishChecked = false;
  abuseChecked = false;
  noneChecked = false;
  appData = {} as AppData;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getAlternateGSRPQualifier();
      this.textDirection = contentService.TextDirection();
      if (this.textDirection == "rtl") {
        this.checkTextAlign = "has-text-right";
      }
      this.appData = this.getAppData();
      if (this.appData != null) {
        this.noGraduationChecked = this.appData.noHighSchoolGraduation;
        this.illiterateChecked = this.appData.illiterate;
        this.noEnglishChecked = this.appData.noEnglishHousehold;
        this.abuseChecked = this.appData.parentExperiencedAbuse;
        this.noneChecked = this.appData.gsrpQualifierNone;
        this.putWorkflowStep( this.appData.workflowId, "AlternateGSRPQualifier") 
      }
    } catch (error) {
      this.showError(error);
    }
  }

  optionChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked === true) {
      this.noneChecked = false;
    }
  }

  noneChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked == true) {
      this.noGraduationChecked = false;
      this.illiterateChecked = false;
      this.noEnglishChecked = false;
      this.abuseChecked = false;
    }
  }

    public oneOrMoreApplies(): boolean {
        return (
            this.noGraduationChecked === true ||
            this.illiterateChecked === true ||
            this.noEnglishChecked === true ||
            this.abuseChecked === true
        );
    }

  public handleNextPageEvent(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    this.appData.noHighSchoolGraduation = this.noGraduationChecked;
    this.appData.illiterate = this.illiterateChecked;
    this.appData.noEnglishHousehold = this.noEnglishChecked;
    this.appData.parentExperiencedAbuse = this.abuseChecked;
    this.appData.gsrpQualifierNone = this.noneChecked;

    const oneOrMoreApplies = this.oneOrMoreApplies();

    // If anything on this list is checked, make sure the list 2
    // values are set to false
    if (oneOrMoreApplies === true) {
      this.clearGSRPQualifiersList2(this.appData);
    }

    this.saveAppData(this.appData);

    if (this.allChildren4AndOver(this.appData)) {
      this.handleAllFourAndOver();
    } else if (this.childrenBothOverAndUnder4(this.appData)) {
      this.handleBothUnderAndOverFour();
    }
  }

   handleAllFourAndOver(): void {
        const rules: QualifierRule[] = [
        { index: [true, County.Wayne, undefined], path: 'MatchGSRPReferral' }
        ,{ index: [true, County.Macomb, undefined], path: 'MatchGSRPReferral' }
        ,{ index: [true, County.Oakland, undefined], path: 'MatchGSRPReferral' }
        ,{ index: [true, County.Washtenaw, undefined], path: 'MatchGSRPReferral' }
        ,{ index: [false, County.Wayne, undefined], path: 'AlternateGSRPQualifierList2' }
        ,{ index: [false, County.Macomb, undefined], path: 'AlternateGSRPQualifierList2' }
        ,{ index: [false, County.Oakland, undefined], path: 'AlternateGSRPQualifierList2' }
        ,{ index: [false, County.Washtenaw, undefined], path: 'AlternateGSRPQualifierList2' }
    ]

    const rule = matchQualifiers(rules, this.oneOrMoreApplies(), this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  handleBothUnderAndOverFour(): void {
    const rules: QualifierRule[] = [
        { index: [true, County.Wayne, undefined], path: 'MatchNoneAndGSRPReferral' }
        ,{ index: [true, County.Macomb, undefined], path: 'MatchNoneAndGSRPReferral' }
        ,{ index: [true, County.Oakland, undefined], path: 'MatchNoneAndGSRPReferral' }
        ,{ index: [true, County.Washtenaw, undefined], path: 'MatchNoneAndGSRPReferral' }
        ,{ index: [false, County.Wayne, undefined], path: 'AlternateGSRPQualifierList2' }
        ,{ index: [false, County.Macomb, undefined], path: 'AlternateGSRPQualifierList2' }
        ,{ index: [false, County.Oakland, undefined], path: 'AlternateGSRPQualifierList2' }
        ,{ index: [false, County.Washtenaw, undefined], path: 'AlternateGSRPQualifierList2' }
    ]

    const rule = matchQualifiers(rules, this.oneOrMoreApplies(), this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  disableNext(): boolean {
    return !(
      this.noGraduationChecked ||
      this.illiterateChecked ||
      this.noEnglishChecked ||
      this.abuseChecked ||
      this.noneChecked
    );
  }
}
